export default "__VITE_ASSET__rfDK_DkD__"